import { useCallback, useState } from 'react';
import { Handle, Position } from 'reactflow';
const handleStyle = { left: 10 };

function TaskEvent({ data }) {

    return (
        <>
            <Handle type="target" position={Position.Top} />
            <div className="max-w-300 mx-auto">
                <div className=''>
                    <div className='px-2 py-1 d-flex gap-1 border-bottom'>
                        <img src='/assets/images/icons/events/task-event.svg' />
                        <span style={{ fontSize: 12, fontWeight: '600' }}>Task Event</span>
                    </div>
                    <div>{data.label}</div>
                    <div className='px-2 py-1' style={{ fontSize: 12, color: '#888' }}>{data.description}</div>
                </div>
            </div>
            <Handle type="source" position={Position.Bottom} id="b" />
        </>
    );
}

export default TaskEvent;